import React, { useState } from 'react'

export interface ProfilerData {
	name: string
	totalTime: number
	runCount: number
	children: Record<string, ProfilerData>
}

interface ProfilerItemProps {
	data: ProfilerData
	parentTotalTime?: number
	isRoot?: boolean
}

const ProfilerItem: React.FC<ProfilerItemProps> = ({ data, parentTotalTime, isRoot = false }) => {
	const [isOpen, setIsOpen] = useState(isRoot)
	const hasChildren = Object.keys(data.children).length > 0

	const toggle = () => {
		if (hasChildren) {
			setIsOpen(!isOpen)
		}
	}

	const percentage = parentTotalTime ? (data.totalTime / parentTotalTime) * 100 : 0

	const getBackgroundColor = (pct: number): string => {
		if (pct <= 2) return 'transparent'
		// Interpolate between white (255, 255, 255) and strong orange/red (255, 100, 100)
		// 100% -> rgb(255, 100, 100)
		// 0% -> rgb(255, 255, 255)
		const greenBlueValue = Math.round(255 - pct * 1.55) // 255 - 155 = 100
		return `rgb(255, ${greenBlueValue}, ${greenBlueValue})`
	}

	return (
		<div
			style={{
				marginLeft: isRoot ? 0 : 20,
				borderLeft: isRoot ? 'none' : '1px solid #ccc',
				paddingLeft: isRoot ? 0 : 5,
			}}
		>
			<div
				onClick={toggle}
				style={{
					cursor: hasChildren ? 'pointer' : 'default',
					padding: '2px 5px',
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					backgroundColor: isRoot ? '#f0f0f0' : getBackgroundColor(percentage),
					borderBottom: '1px solid #eee',
					fontWeight: isRoot ? 'bold' : 'normal',
				}}
			>
				<span>
					{hasChildren && (isOpen ? '▼ ' : '▶ ')}
					{data.name}
					{!isRoot && parentTotalTime && (
						<span style={{ fontSize: '0.8em', color: '#888', marginLeft: '5px' }}>({percentage.toFixed(1)}%)</span>
					)}
				</span>
				<span style={{ fontSize: '0.9em', color: '#666' }}>
					{(data.totalTime * 1000).toFixed(3)} ms | {data.runCount}x
				</span>
			</div>
			{isOpen && hasChildren && (
				<div>
					{Object.values(data.children).map((child) => (
						<ProfilerItem key={child.name} data={child} parentTotalTime={data.totalTime} />
					))}
				</div>
			)}
		</div>
	)
}

export default ProfilerItem
